<template>
  <div class="banner-container">
    <div class="video-container">
      <template v-if="!isMobile">
        <videoLoad v-if="cgVideo" :url="cgVideo || ''"
          :poster="require('@/assets/images/matr1xFireIntro/video_poster.png')">
        </videoLoad>
        <div v-else>
          <img class="video-poster" src="@/assets/images/matr1xFireIntro/video_poster.png" alt="banner" />
        </div>
      </template>
      <div class="mobile-banner-wrap" v-else>
        <img class="video-poster" src="@/assets/images/matr1xFireIntro/matr1x_fire_intro_banner_m.webp" alt="banner" />
        <img class="mask mask-top" :src="require(`@/assets/images/matr1xFireIntro/m_banner_top_mask.png`)" alt="mask" />
      </div>
      <img class="mask" :src="require(`@/assets/images/matr1xFireIntro/${isMobile ? 'm_' : ''}video_bg_mask.png`)"
        alt="mask" />
    </div>
    <div class="banner-main-container">
      <div class="g-grid">
        <div class="grid-area no-up-dot no-down-dot" style="flex: 1">
          <div class="left"></div>
          <div class="left col-grid"></div>
          <div class="center">
            <div v-if="isMobile" class="center-video-pause" @click="startVideo">
              <svg-icon icon-class="video_pause" class-name="pause-svg" style="width: 27px; height: 33px;"></svg-icon>
            </div>
          </div>
          <div class="right col-grid"></div>
          <div class="right"></div>
        </div>
        <div class="grid-area no-up-dot no-down-dot">
          <div class="left"></div>
          <div class="left col-grid"></div>
          <div class="center" style="height: 20px"></div>
          <div class="right col-grid"></div>
          <div class="right"></div>
        </div>
        <div class="grid-area no-up-dot no-down-dot">
          <div class="left"></div>
          <div class="left col-grid">
            <close-svg></close-svg>
          </div>
          <div class="center split-line">MATR1X FIRE</div>
          <div class="right col-grid">
            <close-svg></close-svg>
          </div>
          <div class="right"></div>
        </div>
        <div class="grid-area no-down-dot">
          <div class="left"></div>
          <div class="left col-grid"></div>
          <div class="center long-center center-bg">
            <div class="center-content">
              <action-btns :downloadUrl="downloadUrl" :downloadGift="downloadGift"></action-btns>
            </div>
          </div>
          <div class="right col-grid"></div>
          <div class="right"></div>
        </div>
        <div class="grid-area" style="flex: 0.2"></div>
      </div>
    </div>

    <div v-if="showModal && isMobile" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <video src="@/assets/video/matr1xFireIntro/matr1x_fire_banner_pc.mp4" width="100%" height="auto"
          controls="controls" autoplay x5-video-player-type="h5" x-webkit-airplay="true" webkit-playsinline="true">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import videoLoad from "@/views/components/videoLoad";
import closeSvg from "@/views/components/closeSvg/index.vue";
import customButton from "@/components/customButton/index.vue";
import ActionBtns from "./components/actionBtns/index.vue";
import responsiveMixin from "@/mixins/responsive";
export default {
  name: "Banner",
  mixins: [responsiveMixin],
  components: { videoLoad, customButton, closeSvg, ActionBtns },
  props: {
    cgVideo: {
      type: String,
      default: ""
    },
    downloadUrl: {
      type: Object,
      default: () => { }
    },
    downloadGift: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  mounted() { },
  methods: {
    startVideo() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>